import { CoCotizacionPk } from './../dominio/CoCotizacion';
import { FiltroCoCotizacion } from './../dominio/FiltroCoCotizacion';
import { CoCotizacionServicio } from './../servicio/cotizacion.service';
import { DtoCotizacion } from './../dominio/DtoCotizacion';
import { Component, OnInit, ViewChild, ChangeDetectorRef, ViewChildren, AfterContentChecked, Testability, ɵConsole } from '@angular/core';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { MessageService, ConfirmationService } from 'primeng/api';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import { SelectItem, LazyLoadEvent } from 'primeng/primeng';
import { MaMiscelaneosdetalleServicio } from 'src/app/erp/core/mamiscelaneosdetalle/service/mamiscelaneosdetalle.service';
import { PersonamastSelectorComponent } from 'src/app/erp/core/personamast/vista/selector/personamastselector.component';
import { DtoPersonamast } from 'src/app/erp/core/personamast/dominio/DtoPersonamast';
import { Router, ActivatedRoute } from '@angular/router';
import { PersonamastServicio } from '../../../core/personamast/service/personamast.service';
import { Table } from 'primeng/table';

@Component({
    templateUrl: './cotizacion-listado.component.html'
})

export class CodCotizacionListado extends PrincipalBaseComponent implements OnInit {
    @ViewChild(PersonamastSelectorComponent, { static: false }) personamastSelectorComponent: PersonamastSelectorComponent;
    lstEstados: SelectItem[] = [];
    filtro: FiltroCoCotizacion = new FiltroCoCotizacion();
    seleccionados: DtoCotizacion = new DtoCotizacion();
    filtrofechas: Boolean = true;
    cotizacion: DtoCotizacion = new DtoCotizacion();
    verBoton: Boolean = false;
    titulo: string;
    urlImprimir: String = '';
    action: string;
    lstClientes: any[];
    dtoPersonamast: DtoPersonamast = new DtoPersonamast();

    constructor(
        private router: Router,
        private coCotizacionServicio: CoCotizacionServicio,
        private confirmationService: ConfirmationService,
        private personamastServicio: PersonamastServicio,
        private maMiscelaneosdetalleServicio: MaMiscelaneosdetalleServicio,
        private cdref: ChangeDetectorRef,
        private route: ActivatedRoute,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService
    ) { super(noAuthorizationInterceptor, messageService); }
    paginacion: any = new Object();

    @ViewChild(Table, { static: false }) dt: Table;

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngOnInit() {
        super.ngOnInit();
        this.cargarEstados();
        this.filtro.fechadoc = new Date();
        this.filtro.fechavenc = new Date();
        this.action = this.route.snapshot.params['accion'];
        if (this.action !== undefined) {
            this.cargarPaginacion({ first: 0, rows: 20 });
            this.action = undefined;
        }
    }

    filterClienteSingle(event) {
        let query = event.query;
        this.personamastServicio.listarClientes(query).then(
            res => {
                this.lstClientes = res;
            }
        );
    }

    captureId(event: any) {
        this.dtoPersonamast.persona = event.persona;
        if (!this.estaVacio(this.dtoPersonamast.busqueda)) {
            this.dtoPersonamast.busqueda = this.dtoPersonamast.busqueda.trim();
            this.filtro.nombreCliente = this.dtoPersonamast.busqueda.trim();
        }
        this.filtro.clientenum = event.persona;
    }

    imprimir() {

        if (this.seleccionados === undefined || this.seleccionados === null) {
            this.messageService.add({ severity: 'info', summary: 'Error', detail: 'Debe Seleccionar un Registro' });
            return;
        }

        if (this.seleccionados.numeroDocumento === undefined) {
            this.messageService.add({ severity: 'info', summary: 'Error', detail: 'Debe Seleccionar un Registro' });
            return;
        }

        this.bloquearPagina();
        this.filtro.numerodoc = this.seleccionados.numeroDocumento;
        this.filtro.usuarioActualCompania = this.seleccionados.companiaSocio;
        this.coCotizacionServicio.imprimir(
            this.filtro
        )
            .then(respuesta => {
                if (respuesta) {
                    this.desbloquearPagina();
                    const file = new Blob([respuesta], { type: 'application/pdf' });
                    this.urlImprimir = URL.createObjectURL(file);
                    window.open(this.urlImprimir.toString());
                    this.seleccionados = undefined;
                }
            });
    }

    filaSeleccionada(event) {
        this.verBoton = false;
        if (event.data.estado === 'AP') {
            this.verBoton = true;
        }
    }

    generarPedido() {
        this.router.navigate(['/royal/generarpedido-listado', JSON.stringify(this.seleccionados), 'S'], { skipLocationChange: true });
    }

    defaultBuscar(event?: any) {
        if (event.keyCode === 13) {
            this.buscar();
        }
    }

    cargarEstados() {
        this.bloquearPagina();
        this.lstEstados.push({ label: 'TODO ESTADO', value: null });
        this.maMiscelaneosdetalleServicio.listarPorCabecera('CO', '999999', 'COTIEST').then(
            res => {
                res.forEach(
                    reg => {
                        this.lstEstados.push({ label: reg.descripcionlocal, value: reg.pk.codigoelemento.trim() });
                    }
                );
                this.desbloquearPagina();
            }
        );
    }

    toggleVisibility(e) {
        if (e) {
            this.filtro.fechadoc = new Date();
            this.filtro.fechavenc = new Date();
        } else {
            this.filtro.fechadoc = null;
            this.filtro.fechavenc = null;
        }
    }

    cargarPaginacion(event: LazyLoadEvent) {
        this.bloquearPagina();

        const ss = sessionStorage.getItem('filtrosCotizacion');

        if (ss !== undefined && ss !== null && ss !== 'LIMPIAR') {
            const prefiltro = JSON.parse(ss) as FiltroCoCotizacion;
            if (prefiltro.fechadoc > new Date()) {
                prefiltro.fechadoc = new Date();
                prefiltro.fechavenc = new Date();
            }
            this.filtro = prefiltro;

            if (this.dtoPersonamast.persona == undefined && !this.estaVacio(this.filtro.nombreCliente)) {
                this.dtoPersonamast = new DtoPersonamast();
                this.dtoPersonamast.busqueda = this.filtro.nombreCliente;
            }
        } else {
            if (this.dtoPersonamast.persona == undefined) {
                this.filtro.nombreCliente = undefined;
                this.filtro.clientenum = undefined;
            }
        }

        if (this.filtrofechas === false) {
            this.filtro.fechadoc = null;
            this.filtro.fechavenc = null;

            if (this.filtro.fechadoc != null && this.filtro.fechavenc != null) {
                if (this.filtro.fechadoc > this.filtro.fechavenc) {
                    this.mostrarMensajeAdvertencia('La fecha de Vencimiento debe se mayor o igual que la fecha de Documento');
                    this.desbloquearPagina();
                    return;
                }
            }
        }

        // this.filtro.clientenum = this.dtoPersonamast.persona;
        // this.filtro.nombreCliente = this.dtoPersonamast.busqueda;
        this.filtro.paginacion.listaResultado = [];
        this.filtro.paginacion.registroInicio = event.first;
        this.filtro.paginacion.cantidadRegistrosDevolver = event.rows;
        sessionStorage.setItem('filtrosCotizacion', JSON.stringify(this.filtro));
        this.coCotizacionServicio.listarCotizacionesPaginacion(this.filtro)
            .then(res => {
                this.filtro.paginacion = res;
                this.desbloquearPagina();
            });
    }

    buscar() {
        if (this.filtrofechas === false) {
            if (this.estaVacio(this.dtoPersonamast.persona) && this.estaVacio(this.filtro.numerodoc)) {
                this.mostrarMensajeAdvertencia('Debe Seleccionar un cliente o introducir un número de Cotización');
                return;
            } else if (this.dtoPersonamast.persona === undefined && this.filtro.numerodoc === undefined) {
                this.mostrarMensajeAdvertencia('Debe Seleccionar un cliente o introducir un número de Cotización');
                return;
            }
        }
        sessionStorage.setItem('filtrosCotizacion', 'LIMPIAR');
        this.dt.reset();
    }

    mostrarSelectorCliente() {
        this.personamastSelectorComponent.iniciarComponente();
    }

    limpiarCliente() {
        this.dtoPersonamast = new DtoPersonamast()
    }

    anular(bean: DtoCotizacion) {
        if (bean.estado !== 'AN') {

            if (bean.estado === 'CO') {
                this.coCotizacionServicio.validar(bean).then(
                    response => {
                        if (response > 0) {
                            console.log(response);
                            this.messageService.add({ severity: 'info', summary: 'Información', detail: 'La cotizacion ha generado pedidos, debe anular primero los pedidos.' });
                        }
                        if (response <= 0) {
                            this.confirmationService.confirm({
                                header: 'Confirmación',
                                icon: 'fa fa-question-circle',
                                message: this.getMensajePreguntaAnular(),
                                accept: () => {
                                    this.bloquearPagina();
                                    this.anularValidado(bean);
                                }
                            });
                        }
                    }
                );
            } else {
                this.confirmationService.confirm({
                    header: 'Confirmación',
                    icon: 'fa fa-question-circle',
                    message: this.getMensajePreguntaAnular(),
                    accept: () => {
                        this.bloquearPagina();
                        this.anularValidado(bean);
                    }
                });
            }
        }
        if (bean.estado === 'AN') {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Información', detail: 'La cotizacion ya se encuentra anulada.' });
        }
    }

    anularValidado(bean: DtoCotizacion) {
        this.coCotizacionServicio.solicitudAnular(bean).then(
            respose => {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Información', detail: this.getMensajeAnulado(bean.numeroDocumento) });
                this.dt.reset();
            }
        );
    }

    aprobar(bean: DtoCotizacion) {
        this.bloquearPagina();
        if (bean.estado === 'RV') {
            this.confirmationService.confirm({
                header: 'Confirmación',
                icon: 'fa fa-question-circle',
                message: this.getMensajePreguntaAprobar(),
                accept: () => {
                    this.desbloquearPagina();
                    this.aprobarValidado(bean);
                }
            });
        } else if (bean.estado !== 'RV') {
            this.messageService.add({ severity: 'info', summary: 'Información', detail: 'La cotización solo puede ser aprobada si se encuentra en estado Revisado' });
        }
        this.desbloquearPagina();

    }

    aprobarValidado(bean: DtoCotizacion) {
        this.coCotizacionServicio.solicitudAprobar(bean).then(
            respose => {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Información', detail: this.getMensajeAprobado(bean.numeroDocumento) });
                this.dt.reset();
            }
        );
    }

    nuevo() {
        sessionStorage.setItem('filtrosCotizacion', 'LIMPIAR');
        this.router.navigate(['/royal/cocotizacion-mantenimiento', 'NUEVO'], { skipLocationChange: true });
    }

    modDatosGenerales() {
        if (this.seleccionados == null) {
            this.mostrarMensajeAdvertencia('Seleccionar una cotización');
            return;
        }
    }

    modDetalle() {
        if (this.seleccionados == null) {
            this.mostrarMensajeAdvertencia('Seleccionar una cotización');
            return;
        }
    }


    editar(bean: DtoCotizacion) {
        sessionStorage.setItem('filtrosCotizacion', 'LIMPIAR');
        let ll_retorno;
        if (bean.estado === 'PR') {
            ll_retorno = 0;
        } else if (bean.estado === 'RV') {
            ll_retorno = 0;
        } else {
            ll_retorno = -1;
        }

        if (ll_retorno === -1) {
            this.mostrarMensajeAdvertencia('El Estado del Documento no permite modificaciones');
            return;
        }

        this.titulo = 'EDITAR COTIZACIÓN';
        const pk = new CoCotizacionPk();
        pk.companiasocio = bean.companiaSocio;
        pk.numerodocumento = bean.numeroDocumento;
        this.router.navigate(['/royal/cocotizacion-mantenimiento', 'EDITAR', JSON.stringify(pk)], { skipLocationChange: true });
    }

    ver(bean: DtoCotizacion) {
        this.titulo = 'EDITAR COTIZACIÓN';
        const pk = new CoCotizacionPk();
        pk.companiasocio = bean.companiaSocio;
        pk.numerodocumento = bean.numeroDocumento;
        this.router.navigate(['/royal/cocotizacion-mantenimiento', 'VER', JSON.stringify(pk)], { skipLocationChange: true });
    }

    detallecotizacion(bean: DtoCotizacion) {
        this.router.navigate(['/royal/cocotizacion-mantenimiento', 'VERITEMS', JSON.stringify(bean)], { skipLocationChange: true });
    }

}





